import * as React from 'react';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Landing } from 'pages';
import { Navbar } from 'components';
import LoadingDialog from 'components/Loader';
import '../src/styles/globals.css';
import TermsAndConditionModal from 'pages/TermsAndConditionModal';
import { TermsAndCondition } from 'pages/TermsAndCondition';

const DApp: React.ComponentType = () => {
	return (
		<Router>
			<div>
				<LoadingDialog />
				<TermsAndConditionModal />
				<>
					<Navbar />
					<Switch>
						<Route path="/terms-and-condition">
							<TermsAndCondition />
						</Route>
						{/*<Route path="/create-agent">
							<CreateAgent />
						</Route>*/}
						<Route path="/">
							<Landing />
						</Route>
					</Switch>
				</>
			</div>
		</Router>
	);
};

export default DApp;
